<template>
  <!--下载文件-->
  <tk-container
    :status="status"
    @refresh="getInit"
  >
    <my-header slot="header">{{$route.query.type | pageTitle}}</my-header>
    <!--图片类型渲染-->
    <tk-flex
      wrap
      gutter="5"
      class="p-5"
      v-if="$route.query.type === 'image'"
    >
      <tk-flex
        center
        class="tk-grid-3 "
        v-for="(s, index) in downloadCenter"
        @click.native="downloadUrl(s)"
        :key="index"
      >
        <div class="down-box-image">
          <tk-image :src="s.image" height="88" width="88"></tk-image>
          <tk-flex
            class="down-box-image-load"
            center
            middle
          >
            <tk-flex center column>
              <tk-icon size="22" color="#fff">xiazai</tk-icon>
              <div class="m-t-5" style="color: #fff;">下载 {{(s.downloads ? s.downloads : 0) | transform}} 次</div>
            </tk-flex>
          </tk-flex>
        </div>
      </tk-flex>
    </tk-flex>
    <!--文件类型渲染-->
    <template v-else>
      <card
        :height="60"
        :width="100"
        class="p-12 down-box"
        v-for="(s, index) in downloadCenter"
        :key="index"
      >
        <tk-flex between middle class="full-width">
          <tk-flex middle>
            <tk-icon size="29">{{s.type | iconName}}</tk-icon>
            <tk-flex column class="m-l-15">
              <div class="font-14">{{s | fileName}}</div>
              <div class="caption">下载 {{(s.downloads ? s.downloads : 0) | transform}} 次</div>
            </tk-flex>
          </tk-flex>
          <tkui-button @click="downloadUrl(s)" class="small raised rounded down-box-btn">
            下载
          </tkui-button>
        </tk-flex>
      </card>
    </template>
    <!--下载弹框-->
    <tkui-dialog closeIcon hideAction :show.sync="isDownLoadStatus" center>
      <div class="subhead">
        <tk-flex column class="p-r-24">
          <div class="font-14">{{!downError ? '下载：' + fileName : downError}}</div>
          <div class="m-t-15 font-12"> {{'下载进度：' + percent + '%'}}</div>
        </tk-flex>
        <load-progress
          class="m-t-15"
          v-if="percent"
          :percent="percent"
          :progress-show="true"
          type="rect"
          :rect-width="230"
          :rect-height="5"
          :pathColors="['#f5f5f5', '#7f7eff']"
          :text-color="'rgba(255, 255, 255, 0)'"
        ></load-progress>
      </div>
    </tkui-dialog>
  </tk-container>
</template>

<script>
import loadProgress from '@/components/loadProgress'
import { readyToDownloadFromNet } from '@/assets/help/download'
import { getImageName, waterMarkImage } from '@/assets/help/tool'
export default {
  components: {
    loadProgress
  },
  data () {
    return {
      status: 'loading', // 页面状态
      isDownLoadStatus: false, // 下载状态
      percent: 0, // 下载进度
      downError: null, // 下载提示
      fileName: null, // 当前下载的文件
      downloadCenter: [] // 下载数据
    }
  },
  filters: {
    iconName (type) {
      if (type === 'video') { return 'video' }
      if (type === 'audio') { return 'audio' }
      if (type === 'file') { return 'wenjiangeshi' }
      return ''
    },
    fileName (s) {
      if (s.type === 'image') {
        return s.image.replace('https://s3.moke.cloud/dianpei/', '')
      }
      if (s.type === 'audio' || s.type === 'file' || s.type === 'video') { return s.file.name }
      return ''
    },
    pageTitle (val) {
      if (val === 'image') { return '图片' }
      if (val === 'video') { return '视频' }
      if (val === 'audio') { return '音频' }
      if (val === 'file') { return '文件' }
      return ''
    }
  },
  beforeRouteLeave (to, from, next) {
    next(true)
  },
  activated () {
    this.getInit()
  },
  methods: {
    /**
     * 页面初始化
     * @date: 2020/4/7
     */
    async getInit () {
      try {
        this.setStatusBar('dark')
        let downloadCenter = await this.$tkParse.getList('/classes/downloadCenter', {
          params: {
            limit: 10000,
            order: '-createdAt',
            where: {
              type: this.$route.query.type
            }
          }
        })
        if (!downloadCenter.length) {
          this.status = 'empty'
          return
        }
        this.downloadCenter = downloadCenter.map(s => {
          s.progressShow = false
          s.duration = 1000
          s.percent = 0
          return s
        })
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
    * 下载文件
    * @date: 2020/4/24
    */
    async downloadUrl (s) {
      let url = ''
      let name = ''
      if (s.type === 'image') {
        url = waterMarkImage(s.image)
        name = getImageName(s.image)
      }
      if (s.type === 'audio' || s.type === 'file' || s.type === 'video') { url = s.file.url; name = s.file.name }
      let status = await this.judgeId(s.objectId, 'downloadCenter')
      if (!url || !status) { return this.$tkGlobal.toast.add('没有找到您要下载的文件') }
      this.fileName = name
      this.isDownLoadStatus = true
      let percent = new Promise(resolve => {
        readyToDownloadFromNet(url, s.type, name, {
          downloading: async (progress, text) => {
            this.percent = progress
            if (this.percent === 100) {
              await this.$tkHelper.sleep(300)
              this.isDownLoadStatus = false
              resolve(progress)
            }
          },
          errorDownload: (error) => {
            this.percent = null
            this.downError = error
            this.isDownLoadStatus = false
            resolve(-1)
          }
        })
      })
      let judgePercent = await percent
      // 修改数据库
      if (judgePercent === -1) {
        this.isDownLoadStatus = false
        return this.$tkGlobal.toast.add('下载失败')
      }
      if (judgePercent === 100) {
        if (!s.downloads) { s.downloads = 0 }
        await this.$tkParse.put(`/classes/downloadCenter/${s.objectId}`, {
          downloads: s.downloads + 1
        }).then(() => {
          this.$tkGlobal.toast.add('下载成功')
          s.downloads = s.downloads + 1
          this.$forceUpdate()
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  /*图片样式*/
  .down-box-image {
    width: 88px;
    height: 88px !important;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    .down-box-image-load {
      width: 88px;
      height: 88px;
      background: rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  /*文件样式*/
  .down-box {
    .down-box-btn {
      margin: 0;
      width: 56px;
      height: 27px;
      color: #fff;
      background-color: rgba(89, 127, 251, 1);
    }
    .down-box-progress {
      background: rgba(255, 255, 255, 0);
      width: 56px;
      height: 30px;
    }
  }
</style>
